import { graphql } from "relay-runtime"
import { useMutationWithErrorToast } from "@/hooks/useMutationWithErrorToast"
import { useSetChatAutoTranslationSettingMutation as useSetChatAutoTranslationSettingMutationType } from "@/modules/chats/services/__generated__/useSetChatAutoTranslationSettingMutation.graphql"

const mutation = graphql`
  mutation useSetChatAutoTranslationSettingMutation($input: SetChatAutoTranslationSettingInput!) {
    setChatAutoTranslationSetting(input: $input) {
      appointment {
        id
        chat {
          autoTranslationSetting {
            isLiveTranslationEnabled
            targetAgentLanguage
          }
        }
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

export const useSetChatAutoTranslationSettingMutation = () => {
  return useMutationWithErrorToast<useSetChatAutoTranslationSettingMutationType>(mutation)
}
